import {
  Button,
  TextField,
  Link,
  Paper,
  Box,
  Typography,
} from '@mui/material';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { login } from '../slices/loginSlice';
import { useEffect, useState } from 'react';

export const Login = () => {

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = useSelector(state => state.login.user);

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  // const { loginWithRedirect } = useAuth0();

  useEffect(() => {
    if (user) {
      navigate('/');
    }
  }, [user]);

  const handleLogin = () => {
    // e.preventDefault();
    // const { username, password } = e.target.elements;
    // dispatch(login(username.value, password.value));
    dispatch(login(username, password));
  };

  return (
    <Box>
      {/* <Typography variant='h4'>Login</Typography> */}
      <Paper sx={{ p: '20px', width: 'min(100%, 400px)', m: 'auto', boxSizing: 'border-box', }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
          <TextField id="username" label="Username" variant="filled" fullWidth value={username} onChange={e => setUsername(e.target.value)} />
          <TextField id="password" label="Password" variant="filled" type='password' fullWidth value={password} onChange={e => setPassword(e.target.value)} />
          <Button variant="contained" type="submit" size="small" onClick={handleLogin}>Login</Button>
          <Link href="/sign-up">Sign-Up</Link>
          <Link href="/forgot-password">Forgot Password</Link>
          <Typography variant="caption" color="text.secondary">
            Learn how we handle your information in our <Link component={RouterLink} to="/privacy">Privacy Policy</Link>.
          </Typography>
        </Box>
      </Paper>
    </Box>
    // <Grid item xs={12}>
    //   <Card>
    //     <form onSubmit={handleLogin}>
    //       <Grid
    //         container
    //         item
    //         xs={12}
    //         spacing={4}
    //         sx={{
    //           padding: '1em',
    //         }}
    //       >
    //         <Grid item xs={12}>
    //           Login
    //         </Grid>
    //         <Grid item xs={12}>
    //           <FormControl>
    //             <TextField id="username" label="Username" variant="filled" fullWidth />
    //           </FormControl>
    //         </Grid>
    //         <Grid item xs={12}>
    //           <FormControl>
    //             <TextField id="password" label="Password" variant="filled" type='password' fullWidth />
    //           </FormControl>
    //         </Grid>
    //         <Grid item xs={12}>
    //           <Button variant="contained" type="submit" size="small">Login</Button>
    //           {/* <Button variant="contained" size="small" onClick={() => loginWithRedirect()}>Login 2</Button> */}
    //         </Grid>
    //         <Grid item xs={12}>
    //           <Link href="/sign-up">Sign-Up</Link>
    //           <Link href="">Forgot Password</Link>
    //         </Grid>
    //       </Grid>
    //     </form>
    //   </Card>
    // </Grid>
  );
}